export default (): string => Math.random().toString(36).substr(2, 9);
